/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meta_DescriptionInputs */

const id_meta_description = /** @type {(inputs: Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Database Epic Games Store yang komprehensif: info game, harga, riwayat penjualan, daftar file, dan banyak lagi. Jelajahi game gratis, rilis mendatang, dan wawasan komunitas.`)
};

const ms_meta_description = /** @type {(inputs: Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pangkalan data Epic Games Store yang komprehensif: maklumat permainan, harga, sejarah jualan, senarai fail, dan banyak lagi. Terokai permainan percuma, keluaran akan datang, dan cerapan komuniti.`)
};

const da_meta_description = /** @type {(inputs: Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Omfattende Epic Games Store database: spilinformation, priser, salgshistorik, fillister og mere. Udforsk gratis spil, kommende udgivelser og fællesskabsindsigt.`)
};

const de_meta_description = /** @type {(inputs: Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Umfassende Epic Games Store-Datenbank: Spielinformationen, Preise, Verkaufshistorie, Dateilisten und mehr. Entdecken Sie kostenlose Spiele, kommende Veröffentlichungen und Community-Einblicke.`)
};

const en_us2_meta_description = /** @type {(inputs: Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comprehensive Epic Games Store database: game info, prices, sales history, file lists, and more. Explore free games, upcoming releases, and community insights.`)
};

const es_es2_meta_description = /** @type {(inputs: Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Base de datos completa de la Epic Games Store: información de juegos, precios, historial de ventas, listas de archivos y más. Explora juegos gratis, próximos lanzamientos e información de la comunidad.`)
};

const es_mx2_meta_description = /** @type {(inputs: Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Base de datos completa de la Epic Games Store: información de juegos, precios, historial de ventas, listas de archivos y más. Explora juegos gratis, próximos lanzamientos y perspectivas de la comunidad.`)
};

const fil_meta_description = /** @type {(inputs: Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Komprehensibong Epic Games Store database: impormasyon ng laro, presyo, kasaysayan ng benta, listahan ng file, at marami pa. Galugarin ang mga libreng laro, paparating na release, at mga insight ng komunidad.`)
};

const fr_meta_description = /** @type {(inputs: Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Base de données complète de l'Epic Games Store : infos jeux, prix, historique des ventes, listes de fichiers et plus encore. Explorez les jeux gratuits, les sorties à venir et les analyses de la communauté.`)
};

const it_meta_description = /** @type {(inputs: Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Database completo dell'Epic Games Store: informazioni sui giochi, prezzi, storico vendite, elenchi file e altro ancora. Esplora giochi gratuiti, prossime uscite e approfondimenti della community.`)
};

const hu_meta_description = /** @type {(inputs: Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Átfogó Epic Games Store adatbázis: játékinformációk, árak, eladási előzmények, fájllisták és több. Fedezd fel az ingyenes játékokat, közelgő megjelenéseket és közösségi betekintéseket.`)
};

const nl_meta_description = /** @type {(inputs: Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uitgebreide Epic Games Store database: game-informatie, prijzen, verkoopgeschiedenis, bestandslijsten en meer. Ontdek gratis games, aankomende releases en community-inzichten.`)
};

const no_meta_description = /** @type {(inputs: Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Omfattende Epic Games Store-database: spillinformasjon, priser, salgshistorikk, fillister og mer. Utforsk gratis spill, kommende utgivelser og innsikt fra fellesskapet.`)
};

const pl_meta_description = /** @type {(inputs: Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kompleksowa baza danych Epic Games Store: informacje o grach, ceny, historia promocji, listy plików i więcej. Odkrywaj darmowe gry, nadchodzące premiery i spostrzeżenia społeczności.`)
};

const pt_br2_meta_description = /** @type {(inputs: Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Base de dados completa da Epic Games Store: informações de jogos, preços, histórico de promoções, listas de arquivos e muito mais. Explore jogos grátis, próximos lançamentos e insights da comunidade.`)
};

const pt_meta_description = /** @type {(inputs: Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Base de dados abrangente da Epic Games Store: informações sobre jogos, preços, histórico de vendas, listas de ficheiros e muito mais. Explore jogos grátis, próximos lançamentos e informações da comunidade.`)
};

const ro_meta_description = /** @type {(inputs: Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bază de date cuprinzătoare a Epic Games Store: informații despre jocuri, prețuri, istoric vânzări, liste de fișiere și multe altele. Explorează jocuri gratuite, lansări viitoare și informații din comunitate.`)
};

const fi_meta_description = /** @type {(inputs: Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kattava Epic Games Store -tietokanta: pelitiedot, hinnat, myyntihistoria, tiedostolistaukset ja paljon muuta. Tutki ilmaisia pelejä, tulevia julkaisuja ja yhteisön oivalluksia.`)
};

const sv_meta_description = /** @type {(inputs: Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Omfattande Epic Games Store-databas: spelinfo, priser, försäljningshistorik, fillistor och mer. Utforska gratis spel, kommande släpp och community-insikter.`)
};

const vi_meta_description = /** @type {(inputs: Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cơ sở dữ liệu Epic Games Store toàn diện: thông tin game, giá cả, lịch sử giảm giá, danh sách tệp và hơn thế nữa. Khám phá game miễn phí, bản phát hành sắp tới và thông tin chi tiết từ cộng đồng.`)
};

const tr_meta_description = /** @type {(inputs: Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kapsamlı Epic Games Store veritabanı: oyun bilgisi, fiyatlar, satış geçmişi, dosya listeleri ve daha fazlası. Ücretsiz oyunları, yakında çıkacak sürümleri ve topluluk içgörülerini keşfedin.`)
};

const cs_meta_description = /** @type {(inputs: Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Komplexní databáze Epic Games Store: informace o hrách, ceny, historie slev, seznamy souborů a další. Objevujte hry zdarma, nadcházející vydání a komunitní přehledy.`)
};

const bg_meta_description = /** @type {(inputs: Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Изчерпателна база данни на Epic Games Store: информация за игри, цени, история на продажбите, списъци с файлове и още. Разгледайте безплатни игри, предстоящи издания и анализи от общността.`)
};

const ru_meta_description = /** @type {(inputs: Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Полная база данных Epic Games Store: информация об играх, цены, история продаж, списки файлов и многое другое. Знакомьтесь с бесплатными играми, предстоящими релизами, мнениями и аналитикой сообщества.`)
};

const uk_meta_description = /** @type {(inputs: Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Повна база даних Epic Games Store: інформація про ігри, ціни, історія продажів, списки файлів тощо. Досліджуйте безкоштовні ігри, майбутні релізи та інсайти спільноти.`)
};

const ar_meta_description = /** @type {(inputs: Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`قاعدة بيانات شاملة لـ Epic Games Store: معلومات الألعاب، الأسعار، تاريخ المبيعات، قوائم الملفات، والمزيد. استكشف الألعاب المجانية والإصدارات القادمة ورؤى المجتمع.`)
};

const hi_meta_description = /** @type {(inputs: Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`व्यापक Epic Games Store डेटाबेस: गेम जानकारी, कीमतें, बिक्री इतिहास, फ़ाइल सूचियाँ, और बहुत कुछ। मुफ़्त गेम, आगामी रिलीज़ और सामुदायिक जानकारी।`)
};

const th_meta_description = /** @type {(inputs: Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ฐานข้อมูล Epic Games Store ครบวงจร: ข้อมูลเกม ราคา ประวัติการขาย รายการไฟล์ และอื่น ๆ สำรวจเกมฟรี เกมที่กำลังจะมา และข้อมูลเชิงลึกจากชุมชน`)
};

const ja_meta_description = /** @type {(inputs: Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`包括的な Epic Games Store データベース：ゲーム情報、価格、販売履歴、ファイルリストなど。無料ゲーム、今後のリリース、コミュニティインサイトを探索。`)
};

const zh_cn2_meta_description = /** @type {(inputs: Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`全面的Epic游戏商城数据库：包含游戏信息、价格、促销历史、文件列表等。探索免费游戏、即将发布的游戏及社区洞察。`)
};

const zh_hant1_meta_description = /** @type {(inputs: Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`全面的Epic遊戲商城資料庫：包含遊戲資訊、價格、促銷歷史、檔案清單等。探索免費遊戲、即將發布的遊戲及社群洞察。`)
};

const ko_meta_description = /** @type {(inputs: Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic Games Store 종합 데이터베이스: 게임 정보, 가격, 판매 내역, 파일 목록 등. 무료 게임, 출시 예정작 및 커뮤니티 인사이트를 탐색하세요.`)
};

/**
* | output |
* | --- |
* | "Comprehensive Epic Games Store database: game info, prices, sales history, file lists, and more. Explore free games, upcoming releases, and community insights." |
*
* @param {Meta_DescriptionInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const meta_description = /** @type {((inputs?: Meta_DescriptionInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meta_DescriptionInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_meta_description(inputs)
	if (locale === "ms") return ms_meta_description(inputs)
	if (locale === "da") return da_meta_description(inputs)
	if (locale === "de") return de_meta_description(inputs)
	if (locale === "en-US") return en_us2_meta_description(inputs)
	if (locale === "es-ES") return es_es2_meta_description(inputs)
	if (locale === "es-MX") return es_mx2_meta_description(inputs)
	if (locale === "fil") return fil_meta_description(inputs)
	if (locale === "fr") return fr_meta_description(inputs)
	if (locale === "it") return it_meta_description(inputs)
	if (locale === "hu") return hu_meta_description(inputs)
	if (locale === "nl") return nl_meta_description(inputs)
	if (locale === "no") return no_meta_description(inputs)
	if (locale === "pl") return pl_meta_description(inputs)
	if (locale === "pt-BR") return pt_br2_meta_description(inputs)
	if (locale === "pt") return pt_meta_description(inputs)
	if (locale === "ro") return ro_meta_description(inputs)
	if (locale === "fi") return fi_meta_description(inputs)
	if (locale === "sv") return sv_meta_description(inputs)
	if (locale === "vi") return vi_meta_description(inputs)
	if (locale === "tr") return tr_meta_description(inputs)
	if (locale === "cs") return cs_meta_description(inputs)
	if (locale === "bg") return bg_meta_description(inputs)
	if (locale === "ru") return ru_meta_description(inputs)
	if (locale === "uk") return uk_meta_description(inputs)
	if (locale === "ar") return ar_meta_description(inputs)
	if (locale === "hi") return hi_meta_description(inputs)
	if (locale === "th") return th_meta_description(inputs)
	if (locale === "ja") return ja_meta_description(inputs)
	if (locale === "zh-CN") return zh_cn2_meta_description(inputs)
	if (locale === "zh-Hant") return zh_hant1_meta_description(inputs)
	return ko_meta_description(inputs)
});
export { meta_description as "meta.description" }